<!-- Courier Companies Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Courier Companies Management</h3>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-courier-company-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-light-primary me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>

        <!-- Add Courier Company Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddCourierCompanyModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Courier Company
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-top p-9" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-8 mb-8">
      <div class="col-xxl-10">
        <div class="row g-8">
          <!-- Search -->
          <div class="col-lg-4">
            <label class="fs-6 form-label fw-bold text-dark">Search</label>
            <input
              type="text"
              class="form-control form-control-solid"
              [(ngModel)]="filters.search"
              placeholder="Search courier companies..."
            />
          </div>

          <!-- Date From -->
          <div class="col-lg-4">
            <label class="fs-6 form-label fw-bold text-dark">Date From</label>
            <input
              type="date"
              class="form-control form-control-solid"
              [(ngModel)]="filters.date_from"
            />
          </div>

          <!-- Date To -->
          <div class="col-lg-4">
            <label class="fs-6 form-label fw-bold text-dark">Date To</label>
            <input
              type="date"
              class="form-control form-control-solid"
              [(ngModel)]="filters.date_to"
            />
          </div>
        </div>
      </div>

      <div class="col-xxl-2">
        <div class="row g-8">
          <div class="col-lg-6">
            <label class="fs-6 form-label fw-bold text-dark">&nbsp;</label>
            <button
              type="button"
              class="btn btn-primary w-100"
              (click)="applyFilters()"
            >
              Apply Filters
            </button>
          </div>
          <div class="col-lg-6">
            <label class="fs-6 form-label fw-bold text-dark">&nbsp;</label>
            <button
              type="button"
              class="btn btn-secondary w-100"
              (click)="clearFilters()"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Courier Companies Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-200px">Company Name</th>
            <th class="min-w-200px">Start URL</th>
            <th class="min-w-200px">End URL</th>
            <th class="min-w-120px">Created Date</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="5" class="text-center py-5">
              <div class="d-flex align-items-center justify-content-center">
                <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span class="text-muted">Loading courier companies...</span>
              </div>
            </td>
          </tr>

          <!-- No Data State -->
          <tr *ngIf="!isLoading && courierCompanies.length === 0">
            <td colspan="5" class="text-center py-5">
              <div class="text-center">
                <i class="ki-duotone ki-package fs-3x text-muted mb-3">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </i>
                <p class="text-muted fs-6 mb-0">No courier companies found</p>
              </div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let courierCompany of courierCompanies; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5">
                  <div class="symbol-label bg-light-primary">
                    <i class="ki-duotone ki-package fs-2 text-primary">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                  </div>
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ courierCompany.company_name || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ courierCompany.start_url || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ courierCompany.end_url || '-' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ courierCompany.created_at | date:'dd/MM/yyyy' || '-' }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end flex-shrink-0">
                <!-- Edit Button -->
                <button type="button"
                        class="btn btn-sm btn-icon btn-light-primary"
                        (click)="openEditCourierCompanyModal(courierCompany)"
                        title="Edit Courier Company">
                  <i class="ki-duotone ki-pencil fs-6">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Button -->
                <button type="button"
                        class="btn btn-sm btn-icon btn-light-danger"
                        (click)="deleteCourierCompany(courierCompany)"
                        title="Delete Courier Company">
                  <i class="ki-duotone ki-trash fs-6">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && courierCompanies.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- Courier Company Add/Edit Modal -->
<app-add-edit-courier-company
  (courierCompanyAdded)="onCourierCompanyAdded()"
  (courierCompanyUpdated)="onCourierCompanyUpdated()">
</app-add-edit-courier-company>
